/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import $ from 'jquery';
import i18n from '../../../../i18n/DashboardBundle.properties';
import Backbone from 'backbone';
import BackboneValidation from 'js-sdk/src/common/extension/backboneValidationExtension';

var HyperlinkParameterModel = Backbone.Model.extend({
    idAttribute: 'name',
    defaults: {
        name: '',
        value: ''
    },
    validation: {
        name: function (value) {
            if (!$.trim(value)) {
                return i18n['dashboard.component.dialog.properties.hyperlinks.required.field'];
            }
        },
        value: function (value) {
            if (!$.trim(value)) {
                return i18n['dashboard.component.dialog.properties.hyperlinks.required.field'];
            }
        }
    }
});
_.extend(HyperlinkParameterModel.prototype, BackboneValidation.mixin);
export default HyperlinkParameterModel;